export const PRESETS = {
  minimumWidth: 140,
  default: {
    width: 200,
    height: 200,
  },
};
